import { DISCARDED_RESPONSE_STRINGS, SENSITIVE_RESPONSE_STRINGS } from 'garaje/utils/enums';

import isRemovedString from './is-removed-string';

export default function removedString(value?: string | null): string {
  // A sensitive field the viewer may not access arrives as the [HIDDEN] wire
  // sentinel (with no masking annotation), so render the friendly "Hidden" copy
  // — matching the annotation-masked path in the custom/host columns. Otherwise
  // the raw sentinel leaks into the visitor-log grid cells. Checked before
  // isRemovedString, whose type guard narrows `value` and would make this
  // comparison a no-overlap type error. See VIS-17460.
  if (value === SENSITIVE_RESPONSE_STRINGS.PLACEHOLDER) {
    return SENSITIVE_RESPONSE_STRINGS.DISPLAY_TEXT;
  }
  if (isRemovedString(value)) {
    return DISCARDED_RESPONSE_STRINGS.DISPLAY_TEXT;
  }
  return String(value ?? '');
}
